module.exports = __webpack_public_path__ + "img/fioletdown-white.36819113.png";